import { atom } from 'nanostores'
import type { Config } from '~/config'

export const $config = atom<Config | null>(null)
